import './App.css';
import Welcome from './Components/Welcome';
import Skills from './Components/Skills';
import Services from './Components/Services';

import HireMe from './Components/HireMe';
import Projects from './Components/Projects';
import Footer from './Components/Footer';
import { BrowserRouter} from "react-router-dom";

function App() {
  return (
    <div >
      <BrowserRouter>
        <Welcome />
        <Skills />
        <Services />
        <HireMe />
        <Projects />
        <Footer />
      </BrowserRouter>
        
    </div>
  );
}

export default App;
